



export const ROLES = {
  TECNICO           : '0000000001',
  ADMINISTRADOR     : '0000000002',
  ADMISION          : '0000000006',
  AUX_IMAGENES      : '0000000022',
  AUX_LABORATORIO   : '0000000023',
  DERIVADOR         : '0000000008',
  DIGITADOR         : '0000000012',
  AUDITOR           : '0000000013',
  JEFE_AUDITOR      : '0000000020',
  DOCTOR            : '0000000003',
  JEFE_VALIDACIONES : '0000000019',
  CARTERAS          : '334455',
  JEFE_DERIVADOR    : '0000000018',
  JEFE_MEDICO       : '0000000004',
  PACIENTE          : '',
  AGENDAMIENTO      : '0000000007',
  LABORATORIO       : '0000000010',
  IMAGENES          : '0000000009',
  ESTADISTICAS      : '0000000016',
}